import axios from 'axios'

export default {
    data() {
        return {
            pickupDrops: [
                {id: 0, name: "No Status"},
                {id: 1, name: "Picked Up"},
                {id: 2, name: "Pickup Scheduled"},
            ],
            completeDrops: [
                {id: 0, name: "No Status"},
                {id: 1, name: "Completed"},
                {id: 2, name: "In Progress"}
            ],
            contactDrops: [
                {id: "None", name: "None"},
                {id: "Called", name: "Called"},
                {id: "Texted", name: "Texted"}
            ],
            sTypeDrops: [
                {id: "NP", name: "NP"},
                {id: "TT", name: "TT"},
                {id: "IL", name: "IL"},
                {id: "DT", name: "DT"},
                {id: "DR", name: "DR"},
                {id: "RW", name: "RW"},
                {id: "ORW", name: "ORW"},
                {id: "Permit", name: "Permit"},
                {id: "PC", name: "PC"},
                {id: "PS", name: "PS"}
            ],
            paymentDrops: [
                {id: "Cash", name: "Cash"},
                {id: "Credit Card", name: "Credit"},
                {id: "CC/$", name: "CC/$"},
            ],
            flagDrops: [
                {id: 1, name: "Delete", severity: ""},
                {id: 2, name: "Pending (Tech)", severity: ""},
                {id: 3, name: "Pending (Non-Tech)", severity: ""},
            ],
        }
    },
    methods: {
        postComment(txnID, comment) {
            axios.post(`${localized.baseURL}transaction/comments`, {
                txn_id: txnID,
                comment: comment,
            }, {
                headers: {
                    'X-WP-Nonce': localized.nonce
                }
            })
            .then(response => {
                this.getComments(txnID);
            })
            .catch(error => {
                console.error("Error posting comment:", error);
            });
        },
        getComments(txnID) {
            axios.get(localized.baseURL + 'transaction/comments', {
                params: {
                    txn_id: txnID
                }
            })
            .then(response => {
                this.$store.commit('setComments', response.data);
            })
            .catch(error => {
                console.error(error);
            });
        }
    }
}